import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController, App } from 'ionic-angular';
import { Chart } from "chart.js";
import { DashboardPage } from '../dashboard/dashboard';
import { WelcomePage } from '../../welcome/welcome';
import { Storage } from '@ionic/storage'
import { DashboardProvider } from '../../../providers/dashboard/dashboard';
import { UserProvider } from '../../../providers/user/user';


@Component({
  selector: 'page-generalemployer',
  templateUrl: 'general.html',
})
export class GeneralEmployerPage {

    userToInvite = '';
    userToInvitePH = `mail@societe.fr\nmail2@societe.fr\nmail3@societe.fr\n...`;
    emails:string[] = null;
    mailRegex = /[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/g;
    pendingInvites:any = null;
    userList:any = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController,
    public storageProvider: Storage, public dashboardProvider : DashboardProvider, public userProvider: UserProvider,
    public app: App) {
    menu.enable(true);
  }

  ionViewDidLoad() {

  }


  ngOnInit() {
   this.loadUsers()
  }

  loadUsers(){
      this.dashboardProvider.listPendingUser().subscribe((res) => {
          this.pendingInvites = res.data
      })
      this.userProvider.getAll().subscribe((res) => {
        this.userList = res.data
    })
  }

  inviteUser(){
    this.emails = this.userToInvite.match(this.mailRegex);
    this.dashboardProvider.sendInvitation(this.emails).subscribe((res) => {
        if(res.success){
            this.loadUsers();
            this.emails = null;
            this.userToInvite = '';
        }
    })
  }

  logout(){
    this.storageProvider.remove('access_token').then(() => console.log('logout'))
    this.app.getRootNav().setRoot(WelcomePage)
    .then(() => {
      
    })
  }

}





// WEBPACK FOOTER //
// ./src/pages/employer/general/general.ts